<template lang="pug" src="./client-bonuses.pug"> </template>
<style lang="scss" src="./client-bonuses.scss" scoped> </style>

<script>
import { mapState } from 'vuex';

export default {
    data: () => ({
        requestProcessing: false
    }),
    computed: {
        ...mapState({
            items: state => state.bonuses.client.items,
            pagination: state => state.bonuses.client.pagination
        }),
        headers() {
            return [
                'title', 'description', 'bonusFrequency', 'bonusValue',
                'bonusValueFromDriver', 'startDate', 'endDate', 'isActive',
                'brandId', 'usersCount', 'refillBalance', 'useBalance',
                'leftBalance', 'revertBalance', 'actions'
            ].map(it => ({
                text: this.$vuetify.lang.t(`$vuetify.pages.Bonuses.table.${it}`),
                value: it,
                sortable: false,
                align: 'center'
            }));
        }
    },
    created() {
        this.loadClientBonuses();
        this.$store.dispatch('data/getBrands');
    },
    methods: {
        async loadClientBonuses(page = 1) {
            if (this.requestProcessing) return;

            this.requestProcessing = true;

            await this.$store.dispatch('bonuses/getClientBonuses', { page }).then(() => {
                this.$nextTick(() => {
                    this.requestProcessing = false;
                });
            });
        },
        onPageChange(page) {
            if (page !== this.pagination.page) {
                this.loadClientBonuses(page);
            }
        }
    }
};
</script>
